const TEMPLATE_PREFIX = 'CAPTAIN.ASSISTANTS.CREATE_FLOW.TEMPLATES';

// Template content lives in the locale file as arrays; `tm` returns the raw
// message nodes and `rt` resolves each one to a plain string.
const resolveList = (tm, rt, key) => (tm(key) || []).map(item => rt(item));

const resolveScenarios = (tm, rt, key) =>
  (tm(key) || []).map(scenario => ({
    title: rt(scenario.TITLE),
    description: rt(scenario.DESCRIPTION),
    instruction: rt(scenario.INSTRUCTION),
  }));

const TEMPLATE_KEYS = [
  { key: 'SUPPORT', icon: 'i-lucide-messages-square' },
  { key: 'ORDER', icon: 'i-lucide-package' },
  { key: 'LEADS', icon: 'i-lucide-trending-up' },
  { key: 'TRAVEL', icon: 'i-lucide-plane' },
];

export const buildTemplates = ({ t, tm, rt }) =>
  TEMPLATE_KEYS.map(({ key, icon }) => {
    const prefix = `${TEMPLATE_PREFIX}.${key}`;
    return {
      key,
      icon,
      title: t(`${prefix}.TITLE`),
      description: t(`${prefix}.DESCRIPTION`),
      agentDescription: t(`${prefix}.AGENT_DESCRIPTION`),
      guidelines: resolveList(tm, rt, `${prefix}.GUIDELINES`),
      guardrails: resolveList(tm, rt, `${prefix}.GUARDRAILS`),
      scenarios: resolveScenarios(tm, rt, `${prefix}.SCENARIOS`),
    };
  });

export const buildBlankTemplate = ({ t }) => ({
  key: 'BLANK',
  icon: 'i-lucide-plus',
  title: t(`${TEMPLATE_PREFIX}.BLANK.TITLE`),
  description: t(`${TEMPLATE_PREFIX}.BLANK.DESCRIPTION`),
  agentDescription: '',
  guidelines: [],
  guardrails: [],
  scenarios: [],
});
